<template>
  <div class="my-5" :class="col ? `col-lg-${col}` : ''">
    <!-- :class="{ disabled_input: disabled }" -->
    <div class="input_wrapper top_label select_wrapper">
      <label class="form-label" v-if="placeholder">
        {{ placeholder }}
        <span class="text-danger" v-if="required">*</span>
      </label>
      <multiselect
        :options="optionsList"
        :label="label"
        :track-by="trackBy"
        placeholder=""
        :searchable="true"
        :allow-empty="true"
        :show-labels="false"
        :open-direction="'bottom'"
        :value="value"
        @input="
          updateValue($event);
          $emit('fireInputEvent');
        "
        :multiple="multiple"
        :readonly="readonly"
        :disabled="disabled"
        :close-on-select="focus"
        @open="handleOpen"
        v-bind="$attrs"
        v-on="$listeners"
      >
      </multiselect>
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "BaseSelectInput",
  emits: ["fireInputEvent", "reachEnd"],
  props: {
    // ====== Start:: General Inputs Props ====== //
    col: {
      required: false,
      type: String,
    },
    optionsList: {
      required: true,
    },
    label: {
      type: String,
      default: "name",
    },
    value: {
      required: true,
    },
    placeholder: {
      required: false,
      type: String,
    },
    multiple: {
      required: false,
      type: Boolean,
      default: false,
    },
    trackBy: {
      required: false,
      type: String,
      default: "id",
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
    focus: {
      required: false,
      type: Boolean,
      default: true,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    enableInfiniteScroll: {
      required: false,
      type: Boolean,
      default: false,
    },
    // ====== End:: General Inputs Props ====== //
  },
  data() {
    return {
      scrollContainerEl: null,
      isReachEndEmitted: false,
    };
  },
  beforeDestroy() {
    this.unbindScrollListener();
  },
  methods: {
    updateValue(e) {
      console.log("change", e);

      this.$emit("input", e);
    },
    handleOpen() {
      if (!this.enableInfiniteScroll) {
        return;
      }

      this.$nextTick(() => {
        const nextScrollContainer = this.$el.querySelector(
          ".multiselect__content-wrapper"
        );
        if (!nextScrollContainer) {
          return;
        }

        if (this.scrollContainerEl !== nextScrollContainer) {
          this.unbindScrollListener();
          this.scrollContainerEl = nextScrollContainer;
          this.scrollContainerEl.addEventListener("scroll", this.handleScroll, {
            passive: true,
          });
        }

        this.handleScroll();
      });
    },
    handleScroll() {
      if (!this.scrollContainerEl) {
        return;
      }

      const { scrollTop, clientHeight, scrollHeight } = this.scrollContainerEl;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 8;

      if (isNearBottom && !this.isReachEndEmitted) {
        this.isReachEndEmitted = true;
        this.$emit("reachEnd");
      }

      if (!isNearBottom) {
        this.isReachEndEmitted = false;
      }
    },
    unbindScrollListener() {
      if (!this.scrollContainerEl) {
        return;
      }

      this.scrollContainerEl.removeEventListener("scroll", this.handleScroll);
      this.scrollContainerEl = null;
      this.isReachEndEmitted = false;
    },
  },
};
</script>
